import classNames from "classnames";
import React, { PropsWithChildren } from "react";

import styles from "./index.module.scss";
import { useFocusBlur } from "../../../hooks/useFocusBlur";
import { Input } from "../../atoms/input";

type Props = {
  value: string;
  setValue: (v: string) => void;
  status: "disabled" | "error" | "default";
  onBlur: () => void;
  inputType?: "text" | "number" | "password" | "tel";
  type?: "normal" | "medium" | "thin" | "arrange";
  autoComplete?: string;
  pattern?: string;
  className?: string;
  label?: string;
  example?: string;
  headless?: boolean;
  center?: boolean;
  toHalfWidth?: boolean;
  onlyHead?: boolean;
};

function TextInput(props: PropsWithChildren<Props>) {
  const {
    children,
    className,
    example,
    headless,
    inputType = "text",
    label = "",
    type = "medium",
    center,
    onBlur,
    status,
    autoComplete,
    pattern,
    value,
    setValue,
    toHalfWidth,
    onlyHead,
  } = props;

  const { isFocused, controlFocus } = useFocusBlur({ onBlur });

  const halveWidth = (value: string) => {
    value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    value = value.replace(/＠/g, "@");
    value = value.replace(/。/g, ".");
    value = value.replace(/ー/g, "-");
    value = value.replace(/＿/g, "_");
    value = value.replace(/＋/g, "+");
    return value;
  };

  return (
    <div className={className}>
      <Input
        status={status}
        hasValue={value != ""}
        headless={headless}
        isFocused={isFocused}
        label={label}
      >
        <input
          autoComplete={autoComplete}
          pattern={pattern}
          placeholder={onlyHead || isFocused ? undefined : example || label}
          className={classNames(styles.input, styles[type], {
            [styles.error]: status === "error",
            [styles.textCenter]: center,
            [styles.withIcon]: Boolean(children),
            [styles.headless]: headless,
          })}
          disabled={status === "disabled"}
          type={inputType}
          {...controlFocus}
          value={toHalfWidth ? halveWidth(value) : value}
          onChange={(event) => {
            setValue(event.target.value);
          }}
        />
        {children && <div className={styles.rightDomOn}>{children}</div>}
      </Input>
    </div>
  );
}

export { TextInput };
